import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUnit } from 'effector-react';
import { $initialAccountsStore, $initialCardsStore } from '@lib/store';
import { AccountType } from '@shared/api/rest/accounts';

const TABS = Object.entries(AccountType)
  .slice()
  .reverse()
  .map((x) => ({ label: x[0], value: x[1] }));

export const useTabs = () => {
  const accountsStore = useUnit($initialAccountsStore.store);
  const cardsStore = useUnit($initialCardsStore.store);

  const [tab, setTab] = useState<AccountType | null>(null);

  const loading = useMemo(() => accountsStore.loading || cardsStore.loading, [accountsStore.loading, cardsStore.loading]);
  const hasPayment = useMemo(() => accountsStore.data.some((account) => account.type === AccountType.Payment), [accountsStore.data]);
  const hasCard = useMemo(() => cardsStore.data.length > 0, [cardsStore.data]);

  useEffect(() => {
    if (hasPayment && hasCard) setTab(AccountType.Payment);
    else if (hasPayment) setTab(AccountType.Payment);
    else if (hasCard) setTab(AccountType.Card);
    else setTab(null);
  }, [hasPayment, hasCard]);

  const changeTabHandler = useCallback((tab: AccountType | null) => setTab(tab), []);

  const value = useMemo(
    () => ({
      loading,
      hasCard,
      hasPayment,
      tabs: TABS,
      tab,
      onChangeTab: changeTabHandler,
    }),
    [loading, hasCard, hasPayment, tab, changeTabHandler],
  );

  return value;
};
